import { clearAllSessionData } from "../utils/sessionClearHelper";

export function useClearSessionData() {
  function clearSessionData() {
    clearAllSessionData();
  }

  return clearSessionData;
}
